import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Merge Tailwind class names while resolving conflicts.
 * Use this anywhere class names are conditionally combined.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
